import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'


export default {
name: 'home',
components: {
XHeader,
XButton,
Swiper,
SwiperItem
},
data () {
return {
salesmanCode:'',
isAscendingOrder: false,
designClass: true
}
},
methods: {
toggleSort () {
this.isAscendingOrder = !this.isAscendingOrder
},
toggleDesign () {
this.designClass = !this.designClass
},
classify () {
this.$router.push('/classify')
},
login () {
this.$router.push('/login')
}
},
created () {
}
}



// WEBPACK FOOTER //
// ./src/views/home/script.js